<button
    mat-icon-button
    attr.aria-label="{{
        'shared.skeleton.profileDetails.btnLabel' | translate
    }}"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="isOpen = !isOpen">
    <mat-icon>account_circle</mat-icon>
</button>
<ng-template
    cdkConnectedOverlay
    mat-dialog-content
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="isOpen = false">
    <mat-card>
        <mat-card-header [style.paddingBottom]="'16px'">
            <h2 class="heading-small">{{ currentUser.name }}</h2>
        </mat-card-header>
        <mat-divider />
        <mat-card-content [style.padding]="'16px'">
            <p class="mt-2">
                {{ 'shared.skeleton.profileDetails.email' | translate }}:
                {{ currentUser.email }}
            </p>
            <p [hidden]="hideRole()">
                {{ 'shared.skeleton.profileDetails.userRole' | translate }}:
                {{ roleTranslationKey() | translate }}
            </p>
        </mat-card-content>
    </mat-card>
</ng-template>
